<template>
  <DefaultSection class="section is-medium">
    <div class="container">
      <h2
        class="title is-size-medium has-text-centered has-text-weight-bold mb-6"
      >
        {{ title }}
      </h2>
      <div
        v-if="text"
        class="mb-5 has-text-weight-semibold has-text-centered content"
        v-html="text"
      />
      <div class="columns is-multiline is-centered eq-height">
        <div
          v-for="(statement, key) in statements"
          :key="key"
          class="column is-one-quarter item is-offset-1-mobile is-10-mobile"
        >
          <div class="statement-box" v-html="statement" />
        </div>
      </div>
      <div class="has-text-centered mt-6">
        <VuepalLink
          v-if="link && link.url"
          :to="link.url?.path"
          class="button is-lessmess-desk large has-text-weight-bold is-size-6"
        >
          {{ link.title }}
        </VuepalLink>
      </div>
    </div>
  </DefaultSection>
</template>

<script setup lang="ts">
import type { ParagraphHappyCitizensFragment } from '#graphql-operations'

defineProps<{
  title?: string
  text?: string
  statements?: ParagraphHappyCitizensFragment['statements']
  link?: ParagraphHappyCitizensFragment['link']
}>()

defineBlokkli({
  bundle: 'happy_citizens',
})
</script>

<style scoped lang="scss">
.eq-height {
  flex-wrap: wrap;
  align-items: stretch;
}

.statement-box {
  font-weight: $weight-semibold;
  background-color: $bright-gray-blue;
  color: $white;
  border-radius: 10px;
  padding: 2rem 2rem;
  box-shadow: 0 12px 32px -8px rgba(26, 26, 26, 0.24);
  height: 100%;
}
</style>
